import {
    fetchMonitoredDocument,
    fetchMonitoredDocumentChanges,
    fetchMonitoredDocumentCompare,
    fetchMonitoredDocumentMarkdown,
    fetchMonitoredDocumentVersion,
    fetchMonitoredDocumentVersions,
    setMonitoredDocumentActiveStatus,
    setMonitoredDocumentValidated,
} from '../../../services/MonitoredDocumentService';

import { DEFAULT_PAGE_SIZE } from '../../../constants';

export const FETCH_MONITORED_DOCUMENT_CHANGES = 'FETCH_MONITORED_DOCUMENT_CHANGES';
export const FETCH_MONITORED_DOCUMENT = 'FETCH_MONITORED_DOCUMENT';
export const FETCH_MONITORED_DOCUMENT_VERSIONS = 'FETCH_MONITORED_DOCUMENT_VERSIONS';
export const FETCH_MONITORED_DOCUMENT_MARKDOWN = 'FETCH_MONITORED_DOCUMENT_MARKDOWN';
export const FETCH_MONITORED_DOCUMENT_COMPARE = 'FETCH_MONITORED_DOCUMENT_COMPARE';
export const SET_MONITORED_DOCUMENT_VERSION_VALIDATED = 'SET_MONITORED_DOCUMENT_VERSION_VALIDATED';
export const FETCH_MONITORED_DOCUMENT_VERSION = 'FETCH_MONITORED_DOCUMENT_VERSION';
export const SET_MONITORED_DOCUMENT_ACTIVE_STATUS = 'SET_MONITORED_DOCUMENT_ACTIVE_STATUS';

// ACTION GENERATORS
const fetchMonitoredDocumentChangesAction = (pageNumber = 1, pageSize = DEFAULT_PAGE_SIZE) => ({
    type: FETCH_MONITORED_DOCUMENT_CHANGES,
    payload: fetchMonitoredDocumentChanges(pageNumber, pageSize),
});

const fetchMonitoredDocumentAction = documentId => ({
    type: FETCH_MONITORED_DOCUMENT,
    payload: fetchMonitoredDocument(documentId),
});

const fetchMonitoredDocumentVersionsAction = (documentId, pageNumber, pageSize) => ({
    type: FETCH_MONITORED_DOCUMENT_VERSIONS,
    payload: fetchMonitoredDocumentVersions(documentId, pageNumber, pageSize),
});

const fetchMonitoredDocumentVersionAction = (documentId, versionId) => ({
    type: FETCH_MONITORED_DOCUMENT_VERSION,
    payload: fetchMonitoredDocumentVersion(documentId, versionId),
});

const fetchMonitoredDocumentMarkdownAction = (documentId, versionId) => ({
    type: FETCH_MONITORED_DOCUMENT_MARKDOWN,
    payload: fetchMonitoredDocumentMarkdown(documentId, versionId),
});

const fetchMonitoredDocumentCompareAction = (documentId, oldVersionId, newVersionId) => ({
    type: FETCH_MONITORED_DOCUMENT_COMPARE,
    payload: fetchMonitoredDocumentCompare(documentId, oldVersionId, newVersionId),
});

const setMonitoredDocumentValidatedAction = (documentId, versionId, significant, comment) => ({
    type: SET_MONITORED_DOCUMENT_VERSION_VALIDATED,
    payload: setMonitoredDocumentValidated(documentId, versionId, significant, comment),
});

const setMonitoredDocumentActiveStatusAction = (documentId, isActive) => ({
    type: SET_MONITORED_DOCUMENT_ACTIVE_STATUS,
    payload: setMonitoredDocumentActiveStatus(documentId, isActive),
});

// EXPORT ACTIONS
export {
    fetchMonitoredDocumentChangesAction as fetchMonitoredDocumentChanges,
    fetchMonitoredDocumentAction as fetchMonitoredDocument,
    fetchMonitoredDocumentVersionsAction,
    fetchMonitoredDocumentVersionAction,
    fetchMonitoredDocumentMarkdownAction,
    fetchMonitoredDocumentCompareAction,
    setMonitoredDocumentValidatedAction,
    setMonitoredDocumentActiveStatusAction,
};
